import { AltTransBusCoverage } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { isNotNullish } from "shared/utils/objectUtils";

export function calculateTotalRequiredFromBusCoverage(
  busCoverage: AltTransBusCoverage,
): number {
  if (busCoverage.totalRequired) return busCoverage.totalRequired;

  const busSum = Object.values(busCoverage)
    .filter(isNotNullish)
    .reduce((subtotal, current) => subtotal + current, 0);

  return busSum;
}
